module.exports = __webpack_public_path__ + "static/media/react-1.876a8325.svg";